export enum SummaryConfirmationIconEnum {
  CA = 'caja_ahorro' as any,
  CC = 'cuenta_corriente' as any
}
